module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_5012.7de3ea23.png";